export default __webpack_public_path__ + "static/day-in-life-5846390d9abe6c6ec9fe5346bbbee609.png";